<template>
  <v-btn text color="indigo darken-2" @click="printView(divId)">
    <v-icon left>mdi-printer</v-icon>
    Yazdır
  </v-btn>
</template>

<script>

import {printView} from "../../../helpers";

export default {
  name: "PrintExport",
  props:{
    divId:{
      type: String,
      default: ""
    }
  },
  methods:{
    printView
  }
}
</script>

<style scoped>

</style>